import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import MainLayout, { media } from '../../common/Layout';

const FooterComponent = styled.div`
  border-top: solid 1px #cccccc;

  /* Mobile Device */
  margin-top: 34px;

  ${media.desktop`
    margin-top: 46px;
  `};
`;

const FooterComponentInner = styled(MainLayout)`
  width: 100%;
  justify-content: flex-start;

  /* Mobile Device */
  height: 84px;

  ${media.desktop`
    height: 129px;
  `};
`;

const FooterTitleBox = styled.div`
  /* Mobile Device */
  margin-top: 25px;

  ${media.desktop`
    margin-top: 30px;
  `};
`;

const FooterTitleText = styled.div`
  font-family: 'NotoKrL';
  color: #666666;

  /* Mobile Device */
  font-size: 13px;

  ${media.desktop`
    font-size: 14px;
  `};
`;

class Footer extends React.PureComponent {
  render() {
    return (
      <FooterComponent>
        <FooterComponentInner>
          <FooterTitleBox>
            <FooterTitleText>
              Copyright 2020. Nerdfactory. All rights reserved.
            </FooterTitleText>
          </FooterTitleBox>
        </FooterComponentInner>
      </FooterComponent>
    );
  }
}

export default Footer;
